<template>
    <div>
        <div>
            <div id="accordion">
                <div class="card najiz-card-panel mb-3">
                    <div class="card-header najiz-panel-header" id="parties-heading">
                        <a class="text-dark" data-toggle="collapse" href="#parties-collapse" role="button" aria-expanded="false"
                           aria-controls="parties-collapse">
                            <h4 class="mb-0 py-3">
                                <i class="fal fa-angle-up rotate-icon fa-lg ml-5"></i>
                                <b>
                                    2- الأطراف
                                </b>
                            </h4>
                        </a>
                    </div>

                    <div v-for="(partner, index) in contractDetails.partners" :key="index" id="parties-collapse" class="collapse show" aria-labelledby="parties-heading" data-parent="#accordion">
                        <div class="card-body">
                            <div class="v-card__title v-icon">
                                <span v-if="partner.partnerTarafTypeId == 1"><b>&bull;</b> <b style="text-decoration: underline;"> الطرف الأول: </b></span>
                                <span v-if="partner.partnerTarafTypeId == 2"><b>&bull;</b> <b style="text-decoration: underline;"> الطرف الثاني: </b></span>
                                <span v-if="partner.partnerTarafTypeId == 3"><b>&bull;</b> <b style="text-decoration: underline;"> المحامي: </b></span>
                            </div>
                            <!-- #region الطرف ممثل نظامي -->
                            <ContractAuthorizerComponent v-if="partner.partnerSefaTypeId === sefaTypeEnum.Authorizer" :partner="partner" />
                            <!-- #endregion -->
                            <!-- #region الطرف المنشأة -->
                            <ContractEntityComponent v-else-if="partner.partnerSefaTypeId === sefaTypeEnum.Entity" :partner="partner" />
                            <!-- #endregion -->
                            <!-- #region الطرف وكيل -->
                            <ContractAttorneyAgentComponent v-else-if="partner.partnerSefaTypeId === sefaTypeEnum.AttorneyAgent" :partner="partner" />
                            <!-- #endregion -->
                            <!-- #region الطرف أصالة عن نفسه او محامي او ولي على طالب او ولي او وصي بموجب صك وصية -->
                            <ContractPersonComponent v-else :showIban="true" :showContacts="true" :partner="partner" />
                            <!-- #endregion -->

                            <div v-if="partner.sourcePersons && (partner.partnerSefaTypeId === sefaTypeEnum.Wali || partner.partnerSefaTypeId === sefaTypeEnum.Wasi)">
                                <div v-for="(sourcePerson, index) in partner.sourcePersons" :key="index" v-if="partner.sourcePersons">
                                    <PartnerSourcePersonsComponent :sourcePerson="sourcePerson" :parentSefa="partner.partnerSefaTypeId" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Vue, Prop } from 'vue-property-decorator';

    import { ContractDetails } from '@/models/contract.model';
    import { TarafTypeEnum } from '@/enums/tarafTypeEnum';
    import { SefaTypeEnum } from '@/enums/SefaTypeEnum';

    import PartnerSourcePersonsComponent from '@/components/contract/contract-partner-sourcePersons.vue';
    import ContractAuthorizerComponent from '@/components/contract/partnerType/contract-authorizer.component.vue';
    import ContractEntityComponent from '@/components/contract/partnerType/contract-entity.component.vue';
    import ContractAttorneyAgentComponent from '@/components/contract/partnerType/contract-attorney-agent.component.vue';
    import ContractPersonComponent from '@/components/contract/partnerType/contract-person.component.vue';
    @Component({
        components: {
            PartnerSourcePersonsComponent,
            ContractAuthorizerComponent,
            ContractEntityComponent,
            ContractAttorneyAgentComponent,
            ContractPersonComponent,
        }
    })

    export default class ContractPartnersComponent extends Vue {
        @Prop({ required: true }) contractDetails!: ContractDetails;

        tarafTypeEnum = TarafTypeEnum;
        sefaTypeEnum = SefaTypeEnum;
    }
</script>
